module.exports = __webpack_public_path__ + "img/zhaoxiang.e1c58115.png";